import React, { useMemo } from "react";
import { useLogs } from "../context/LogContext";
import "../styles.css";

const CHANNELS = [
  { key: "byosync", title: "BYOSYNC", tone: "accent" },
  { key: "aadhaar", title: "AADHAAR", tone: "info" },
  { key: "apple_face_id", title: "APPLE FACE ID", tone: "success" },
  { key: "mpc", title: "MPC", tone: "warn" },
];

const LogCard = ({ title, tone, logs, onClear, topSlot }) => {
  const reversed = useMemo(() => [...(logs || [])].reverse(), [logs]);

  return (
    <div className={`log-card log-card--${tone}`}>
      <div className="log-card__header">
        <div className="log-card__title">
          <span>{title}</span>
          <span className="log-card__count">{logs?.length || 0}</span>
        </div>
        <button className="log-card__btn" onClick={onClear} type="button">
          Clear
        </button>
      </div>
      <div className="log-card__body">
        {topSlot ? <div className="log-meta">{topSlot}</div> : null}
        {reversed.length === 0 ? (
          <div className="log-empty">No logs yet.</div>
        ) : (
          reversed.map((l, i) => (
            <div className="log-line" key={`${title}-${i}`}>
              {l}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

const LogPanel = () => {
  const { logsByChannel, channelMeta, clearLogs, clearAllLogs } = useLogs();

  return (
    <div className="log-dashboard">
      <div className="log-dashboard__topbar">
        <div className="log-dashboard__heading">
          <div className="log-dashboard__title">Activity Logs</div>
          <div className="log-dashboard__subtitle">
            Split into 4 separate feeds
          </div>
        </div>
        <button className="log-dashboard__clearall" onClick={clearAllLogs} type="button">
          Clear All
        </button>
      </div>

      <div className="log-grid">
        {CHANNELS.map((c) => (
          <LogCard
            key={c.key}
            title={c.title}
            tone={c.tone}
            logs={logsByChannel?.[c.key] || []}
            onClear={() => clearLogs(c.key)}
            topSlot={
              c.key === "aadhaar" ? (
                channelMeta?.aadhaar?.photo ? (
                  <div className="aadhaar-preview">
                    <div className="meta-label">Captured Photo (Aadhaar)</div>
                    <img
                      className="meta-photo"
                      src={channelMeta.aadhaar.photo}
                      alt="Captured"
                    />
                  </div>
                ) : (
                  <div className="meta-hint">Scan will capture and show a photo here.</div>
                )
              ) : c.key === "apple_face_id" ? (
                channelMeta?.apple_face_id?.distanceHash ? (
                  <div className="hash-box">
                    <div className="meta-label">
                      Distance Hash{channelMeta.apple_face_id.frame ? ` (Frame ${channelMeta.apple_face_id.frame})` : ""}
                    </div>
                    <div className="meta-hash">{channelMeta.apple_face_id.distanceHash}</div>
                  </div>
                ) : (
                  <div className="meta-hint">Distance hash will appear during scan.</div>
                )
              ) : c.key === "mpc" ? (
                channelMeta?.mpc?.hash1 ? (
                  <div className="hash-box">
                    <div className="meta-label">
                      MPC Hashes{channelMeta.mpc.frame ? ` (Frame ${channelMeta.mpc.frame})` : ""}
                    </div>
                    <div className="meta-hash">Hash-1: {channelMeta.mpc.hash1}</div>
                    <div className="meta-hash">Hash-2: {channelMeta.mpc.hash2}</div>
                    <div className="meta-hash">Hash-3: {channelMeta.mpc.hash3}</div>
                  </div>
                ) : (
                  <div className="meta-hint">MPC hashes will appear during scan.</div>
                )
              ) : null
            }
          />
        ))}
      </div>
    </div>
  );
};

export default LogPanel;
